import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=24a2c9ca&scoped=true"
import script from "./Ticket.vue?vue&type=script&lang=ts"
export * from "./Ticket.vue?vue&type=script&lang=ts"
import style0 from "./Ticket.vue?vue&type=style&index=0&id=24a2c9ca&prod&lang=scss"
import style1 from "./Ticket.vue?vue&type=style&index=1&id=24a2c9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a2c9ca",
  null
  
)

export default component.exports